import { Paginator, PaginatorProps } from '../paginator/Paginator';

import { Widget, WidgetProps } from './Widget';

import styles from './widgetWithPaginator.module.scss';

const MAX_ENTRIES_DOC_VIEWS = 10_000;

export type WidgetWithPaginatorProps = WidgetProps &
  Omit<PaginatorProps, 'totalPages' | 'shownEntries' | 'disabled'> & {
    selectedRowsCount?: number;
    isDocViewWidget?: boolean;
    paginatorDisabled?: boolean;
  };

export function WidgetWithPaginator({
  activePage,
  activePaginationSize,
  availablePaginationSizes,
  children,
  onPageChange,
  onPaginationSizeChange,
  totalEntries,
  selectedRowsCount,
  paginatorDisabled,
  isDocViewWidget,
  ...props
}: WidgetWithPaginatorProps) {
  return (
    <Widget {...props}>
      {children}
      <div className={styles['paginator__root']}>
        <Paginator
          activePage={activePage}
          activePaginationSize={activePaginationSize}
          availablePaginationSizes={availablePaginationSizes}
          onPageChange={(page) => {
            onPageChange(page);
          }}
          onPaginationSizeChange={(newPaginationSize) => {
            onPageChange(0);
            onPaginationSizeChange(newPaginationSize);
          }}
          totalEntries={totalEntries}
          selectedRowsCount={selectedRowsCount}
          entryLimit={isDocViewWidget ? MAX_ENTRIES_DOC_VIEWS : undefined}
          disabled={paginatorDisabled}
        />
      </div>
    </Widget>
  );
}
